/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const PspChannelPaymentTypesR = t.interface({
  payment_types: t.readonlyArray(t.string, "array of string")
});

// optional attributes
const PspChannelPaymentTypesO = t.partial({});

export const PspChannelPaymentTypes = t.intersection(
  [PspChannelPaymentTypesR, PspChannelPaymentTypesO],
  "PspChannelPaymentTypes"
);

export type PspChannelPaymentTypes = t.TypeOf<typeof PspChannelPaymentTypes>;
